<template>
  <div class="page-content">
    <b-overlay id="overlay-process" :show="loading" rounded="sm">

      <section class="processTable">
        <b-table :items="processData" :fields="headers" striped hover bordered outlined sticky-header
          head-variant="dark" small >
          <template #cell(deleteBtn)="data" class="actionProcessBtn">
            <input type="checkbox" name="" id="" @click="handleCheckProcess(data, $event)">
          </template>

          <template #cell(description)="data" sortKey>
            <b-form-input v-if="processData[data.index].isEdit && selectedCell === 'description'" type="text"
              v-model="processData[data.index].description"></b-form-input>
            <span v-else @click="editCellHandler(data, 'description')">{{ data.value }}</span>
          </template>

          <template #cell(processBTN)="data" class="actionProcessBtn">
            <img src="@/assets/AddRespButton.png" :alt="$t('config-resp')" :title="$t('config-resp')"
              @click="openResponsibleModal(data)" />
          </template>

        </b-table>
      </section>

      <section class="processBtn">
        <img src="@/assets/criarocorrencia.png" :alt="$t('adicionar-nova-linha')" :title="$t('adicionar-nova-linha')"
          @click="addLines" />
        <img src="@/assets/excluir.png" :alt="$t('excluir')" :title="$t('excluir')"
          @click="$bvModal.show('confirmDeleteData')" />
        <img src="@/assets/salvar.png" :alt="$t('salvar')" :title="$t('salvar')" @click="saveProcesses()" />
        <img src="@/assets/cancel.png" :alt="$t('cancelar')" :title="$t('cancelar')"
          @click="$bvModal.show('confirmResetData')" />
      </section>

      <b-modal id="confirmResetData" :title="$t('atencao')" ok-variant=danger :ok-title="$t('yes')"
        :cancel-title="$t('no')" @ok="reset">{{ $t('confirma-o-descarte-das-alteracoes-0') }}</b-modal>
      <b-modal id="confirmDeleteData" :title="$t('atencao')" ok-variant=danger :ok-title="$t('yes')"
        :cancel-title="$t('no')" @ok="removeProcess">{{ $t('deseja-excluir-os-processos-selecionados') }}</b-modal>

      <b-modal id="DeletionNotAllowed" size="md" hide-footer :title="$t('alerta')" :no-close-on-backdrop="true">
        <MessageBox :info="deletionNotAllowed" modelname="DeletionNotAllowed" />
      </b-modal>

      <b-modal size="xl" id="responsiblesModal" :title="this.$t('config-resp')" hide-footer no-close-on-backdrop
        no-close-on-esc hide-header-close>
        <ResponsiblesModal :processObj="currentProcessObj" :responsibleList="responsibleList"
          :cancelFunc="() => this.$bvModal.hide('responsiblesModal')"
          :saveFunc="() => this.$bvModal.hide('responsiblesModal')" 
          :workshiftNames="this.headers" />
      </b-modal>

    </b-overlay>
  </div>

</template>

<script>
import { mapState } from "vuex";
import * as cGridAll from "vue-cheetah-grid";
import * as cheetahGrid from "cheetah-grid";
import { defaultSuccess, urlMainAPI } from "@/global";
import MessageBox from "@/components/template/MessageBoxModal.vue";
import axios from "axios";
import ResponsiblesModal from '@/components/analytics/ResponsiblesModal'

var inputEditor = new cheetahGrid.columns.action.InlineInputEditor();

inputEditor.disabled = (record) => {
  if (record != null || record != undefined) {
    return false;
  }
};

export default {
  description: "GridProcess",
  computed: mapState(["user"]),
  components: {
    ...cGridAll,
    MessageBox,
    ResponsiblesModal
  },
  watch: {
    json() { },
  },
  data: function () {
    return {
      headers: [
        { key: 'deleteBtn', label: '', thStyle: { width: "2%" } },
        { key: 'description', label: this.$t('processo'), thStyle: { width: "28%" } },
        { key: 'workshiftAMainResponsible', label: this.$t('turnA') , thStyle: { width: "20%" } },
        { key: 'workshiftBMainResponsible', label: this.$t('turnB'), thStyle: { width: "20%" } },
        { key: 'workshiftCMainResponsible', label: this.$t('turnC'), thStyle: { width: "20%" } },
        { key: 'processBTN', label: '', thStyle: { width: "5%" } }
      ],
      processData: [],
      backupData: [],
      selectedCell: null,
      currentProcessObj: {},
      responsibleList: [],
      checkedProcess: [],
      emptyWorkshiftResp: {
        mainResponsibleId: {
          id:0,
          name:"",
          email:"",
          receiveAutonomousWarning: false,
          system: "P",
          unitId: 1,
        },
        
        auxResponsiblesId: []
      },

      emptyRow: {
        id: 0,
        description: "Novo Processo",
        solvaceLocation: null,
        workshiftAMainResponsible: "",
        workshiftBMainResponsible: "",
        workshiftCMainResponsible: "",
      },

      loading: true,
      deletionNotAllowed: "",

    };
  },
  methods: {
    editCellHandler(data, name) {
      this.processData = this.processData.map(item => ({ ...item, isEdit: false }));
      this.processData[data.index].isEdit = true;
      this.selectedCell = name
    },

    handleCheckProcess(data, evt) {
      if (data.index == undefined) return;

      if (evt.target.checked == true) {
        this.checkedProcess.push(this.processData[data.index]);
      } else {
        this.checkedProcess = this.checkedProcess.filter(item => item.id != this.processData[data.index].id)
      }
    },

    addLines() {
      let empty = {
        ...this.emptyRow,
        workshiftAResponsibles: { ...this.emptyWorkshiftResp },
        workshiftBResponsibles: { ...this.emptyWorkshiftResp },
        workshiftCResponsibles: { ...this.emptyWorkshiftResp },
      }

      this.processData.push(empty, empty, empty, empty)
    },

    async loadProcess() {
      this.loading = true;
      defaultSuccess(this.$t('carregando-processos'));
      const url = `${urlMainAPI}/getprocess`;
      await axios
        .get(url)
        .then((res) => {
          if (res.data.length == 0) return;

          this.processData = res.data.map(item => {
            if (item.workshiftAResponsibles && item.workshiftAResponsibles != "" && item.workshiftAResponsibles != null && item.workshiftAResponsibles != "null") {
              item.workshiftAResponsibles = JSON.parse(item.workshiftAResponsibles);
              item.workshiftAMainResponsible = item.workshiftAResponsibles.mainResponsibleId.name
            } else {
              item.workshiftAResponsibles = { ...this.emptyWorkshiftResp };
              item.workshiftAMainResponsible = '';
            }

            if (item.workshiftBResponsibles && item.workshiftBResponsibles != "" && item.workshiftBResponsibles != null && item.workshiftBResponsibles != "null") {
              item.workshiftBResponsibles = JSON.parse(item.workshiftBResponsibles);
              item.workshiftBMainResponsible = item.workshiftBResponsibles.mainResponsibleId.name
            } else {
              item.workshiftBResponsibles = { ...this.emptyWorkshiftResp };
              item.workshiftBMainResponsible = '';
            }

            if (item.workshiftCResponsibles && item.workshiftCResponsibles != "" && item.workshiftCResponsibles != null && item.workshiftCResponsibles != "null") {
              item.workshiftCResponsibles = JSON.parse(item.workshiftCResponsibles);
              item.workshiftCMainResponsible = item.workshiftCResponsibles.mainResponsibleId.name
            } else {
              item.workshiftCResponsibles = { ...this.emptyWorkshiftResp };
              item.workshiftCMainResponsible = '';
            }

            return {
              ...item,
              isEdit: false
            }
          });
          this.backupData = [...this.processData];
          defaultSuccess(this.$t('processos-carregados'));
        })
        .catch();
      this.checkedProcess = [];
      this.loading = false;
    },

    reset() {
      this.processData = [...this.backupData];
      defaultSuccess(this.$t('alteracoes-descartadas'));
    },

    openResponsibleModal(data) {
      if (data.index == undefined) return;
      this.currentProcessObj = this.processData[data.index];
      this.$bvModal.show('responsiblesModal');
    },

    formatProcess(process) {
      return process.map(item => ({
        id: item.id,
        description: item.description,
        solvaceLocation: item.solvaceLocation,
        workshiftAResponsibles: JSON.stringify(item.workshiftAResponsibles) ? JSON.stringify(item.workshiftAResponsibles) : null,
        workshiftBResponsibles: JSON.stringify(item.workshiftBResponsibles) ? JSON.stringify(item.workshiftBResponsibles) : null,
        workshiftCResponsibles: JSON.stringify(item.workshiftCResponsibles) ? JSON.stringify(item.workshiftCResponsibles) : null
      })).filter(proc => proc.description != "" && proc.description != "Novo Processo");
    },

    async getResponsibles() {
      const unitId = this.user.UnitId || 1;

      const url = `${urlMainAPI}/getresponsiblesbyunit/${unitId}`;
      await axios.get(url).then((res) => {
        this.responsibleList = res.data.responsibleList.filter(user => user.handleOccurrences === true);
      });
    },

    async saveProcesses() {
      this.loading = true;
      let processToSave = this.formatProcess(this.processData);

      const url = `${urlMainAPI}/saveprocess`;

      await axios
        .post(url, processToSave)
        .then(() => {
          this.processData = [...processToSave];
          this.backupData = this.processData;
          defaultSuccess(this.$t('processos-salvos-com-sucesso'));
        })
        .catch();
        await this.loadProcess();
        this.loading = false;
    },

    async removeProcess() {
      let processToSave = this.formatProcess(this.checkedProcess);

      const url = `${urlMainAPI}/deleteprocess`;

      await axios
        .post(url, processToSave)
        .then(async (res) => {
          let processNotDelete = res.data.processNotDelete;
          if (processNotDelete.length > 0) {
            let text = this.$t('o-s-processo-s');
            processNotDelete.forEach((proc) => {
              text += ` ${proc.description == '' ? + this.$t('vazio') : proc.description};`;
            });
            text += this.$t('nao-pode-m-ser-removido-s')
            text += this.$t('pois-possui-em-configuracao-de-grandeza');
            this.deletionNotAllowed = text;
            this.$bvModal.show("DeletionNotAllowed");
          } else {
            defaultSuccess(this.$t('processo-s-removido-s-com-sucesso'));
          }

          await this.loadProcess();
        })
        .catch();
    },

    async getWorkshiftLabels() {
        await axios.get(`${urlMainAPI}/getworkshift`).then(res => {
          let labels = res.data.map(item => item.description);
          this.headers.forEach(item => {
            if(item.key == "workshiftAMainResponsible") item.label = labels[0];
            if(item.key == "workshiftBMainResponsible") item.label = labels[1];
            if(item.key == "workshiftCMainResponsible") item.label = labels[2];
          })
        }).catch();
    }
  },

  async created() {
    await this.getWorkshiftLabels();
    await this.loadProcess();

    await this.getResponsibles();

    if (this.user.Permissions.enviarocorrenciasparasolvace != undefined && this.user.Permissions.enviarocorrenciasparasolvace.allowed == true) {
      this.headers.splice(2, 0,
        { key: 'solvaceLocation', label: this.$t('location-rca') }
      );
    }
  },

};
</script>

<style scoped>
.processTable div {
  height: calc(92vh - 220px);
  max-height: calc(92vh - 220px);
  overflow-y: auto;
  margin-bottom: 1rem;
}

.processBtn {
  display: flex;
  column-gap: 1.5rem;
  align-items: center;
  justify-content: flex-end;
}

.processBtn img {
  height: 38px;
}

.actionProcessBtn {
  width: 10px;
}

img {
  cursor: pointer;
}
</style>